// @ts-check

export default {
    /**
     *
     * @param {HTMLInputElement | HTMLTextAreaElement} el
     */
    mounted(el) {
        el.addEventListener("keydown", (event) => {
            const key = event.key;
            if (
                (key.length === 1 && isNaN(Number(key))) ||
                (key === "." && el.value.includes("."))
            ) {
                event.preventDefault();
            }
        });
    }
};
